module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_19.png?1b106d650207a9f04a7ffb0b7b1d9cdf";